import { Routes } from '@angular/router';

export const LegalRoutes: Routes = [
  {
    path: 'terms-of-service',
    loadComponent: () =>
      import('./legal-page.component').then(m => m.LegalPageComponent),
    data: { slug: 'terms-of-service', titleKey: 'legal.termsOfService' },
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./legal-page.component').then(m => m.LegalPageComponent),
    data: { slug: 'privacy-policy', titleKey: 'legal.privacyPolicy' },
  },
  {
    path: 'cookie-policy',
    loadComponent: () =>
      import('./legal-page.component').then(m => m.LegalPageComponent),
    data: { slug: 'cookie-policy', titleKey: 'legal.cookiePolicy' },
  },
  {
    path: 'data-processing-statement',
    loadComponent: () =>
      import('./legal-page.component').then(m => m.LegalPageComponent),
    data: { slug: 'data-processing-statement', titleKey: 'legal.dataProcessingStatement' },
  },
  {
    path: 'acceptable-use-policy',
    loadComponent: () =>
      import('./legal-page.component').then(m => m.LegalPageComponent),
    data: { slug: 'acceptable-use-policy', titleKey: 'legal.acceptableUsePolicy' },
  },
  {
    path: 'platform-disclaimer',
    loadComponent: () =>
      import('./legal-page.component').then(m => m.LegalPageComponent),
    data: { slug: 'platform-disclaimer', titleKey: 'legal.platformDisclaimer' },
  },
  {
    path: 'payment-terms',
    loadComponent: () =>
      import('./legal-page.component').then(m => m.LegalPageComponent),
    data: { slug: 'payment-terms', titleKey: 'legal.paymentTerms' },
  },
  {
    path: 'rfq-terms',
    loadComponent: () =>
      import('./legal-page.component').then(m => m.LegalPageComponent),
    data: { slug: 'rfq-terms', titleKey: 'legal.rfqTerms' },
  },
  {
    path: 'verified-status-terms',
    loadComponent: () =>
      import('./legal-page.component').then(m => m.LegalPageComponent),
    data: { slug: 'verified-status-terms', titleKey: 'legal.verifiedStatusTerms' },
  },
  {
    path: 'golden-thread-disclaimer',
    loadComponent: () =>
      import('./legal-page.component').then(m => m.LegalPageComponent),
    data: { slug: 'golden-thread-disclaimer', titleKey: 'legal.goldenThreadDisclaimer' },
  },
  {
    path: '',
    loadComponent: () =>
      import('./legal-hub.component').then(m => m.LegalHubComponent),
    data: { titleKey: 'legal.hub.pageTitle' },
  },
];
